import Link from 'next/link';

// Constant
import { FALLBACK_SRC } from '@shared/constants';

// Utils
import { combineClasses } from '@shared/utils';

// Components
import { ImageFallback, Button } from '@shared/ui';
export interface ErrorContentProps {
  imageSrc: string;
  imageAlt: string;
  imageClass?: string;
  buttonLabel: string;
  buttonLink?: string;
  onClick?: () => void;
  title?: string;
  subtitle?: string;
  subtitleClass?: string;
  className?: string;
}
export const ErrorContent = ({
  imageSrc,
  imageAlt,
  imageClass = '',
  buttonLabel,
  buttonLink = '',
  onClick,
  title,
  subtitle,
  subtitleClass = '',
  className = ''
}: ErrorContentProps) => {
  return <div className={combineClasses('flex flex-col w-full h-full px-4 items-center', 'bg-primary-100', className)} data-sentry-component="ErrorContent" data-sentry-source-file="index.tsx">
      <div className={combineClasses('relative', imageClass)}>
        <ImageFallback src={imageSrc} fallbackSrc={FALLBACK_SRC.DEFAULT} alt={imageAlt} fill className="object-cover" sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" data-sentry-element="ImageFallback" data-sentry-source-file="index.tsx" />
      </div>

      {title && <h2 className="font-light text-center text-md xs:text-lg sm:text-2xl md:text-4xl text-primary-850">
          {title}
        </h2>}
      {subtitle && <p className={combineClasses('text-2xs tracking-widest md:text-xs text-secondary md:tracking-[4px]', subtitleClass)}>
          {subtitle}
        </p>}
      {buttonLink ? <Link href={buttonLink} className="uppercase text-3xs font-semibold text-white bg-secondary py-2.5 w-full max-w-btn-back mt-8 text-center rounded-sm">
          {buttonLabel}
        </Link> : <Button onClick={onClick} className="text-3xs py-2.5 font-semibold w-full max-w-btn-back mt-8">
          {buttonLabel}
        </Button>}
    </div>;
};